export default __webpack_public_path__ + "static/media/003-salt.eb7674c4.svg";